const data = {
  title: {
    es: "Formentera20: Cultura digital. Nuevas tecnologías. Comunicación",
    ca: "Formentera20: Cultura digital. Noves tecnologíes. Comunicació",
    en: "Formentera20: Digital culture. New technologies. Communication",
  },
  description: {
    es: `XIIª edición: 2 – 4 de octubre de 2025. Transformación digital. Social media. Marketing`,
    ca: `XIIª edició: 2 – 4 d'octubre de 2025. Transformació digital. Social media. Marketing`,
    en: `XIIth edition: 2nd – 4th October of 2025. Digital transformation. Social media. Marketing`,
  },
  keywords: "formentera, digital, tecnologia, social media, marketing",
  favicon: "/favicon.png",
}
export default data
